export default "__VITE_PUBLIC_ASSET__ec01c224__"